(function () {
    'use strict';

    document.querySelectorAll('.anchor-content-with-sidebar-block').forEach(function (block) {
        var links = block.querySelectorAll('.anchor-nav a');
        var sections = block.querySelectorAll('.content-section');
        if (!links.length || !sections.length) return;

        // Smooth scroll on anchor click
        links.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                var target = document.getElementById(this.getAttribute('href').substring(1));
                if (!target) return;
                var offset = 100;
                window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
                links.forEach(function (l) { l.classList.remove('active', 'fw-semibold'); });
                this.classList.add('active', 'fw-semibold');
            });
        });

        // Scroll spy throttled with rAF
        var ticking = false;
        window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
                var offset = 120;
                var currentId = '';
                sections.forEach(function (section) {
                    var h = section.querySelector('h1, h2, h3, h4, h5, h6');
                    if ((h || section).getBoundingClientRect().top <= offset) currentId = section.getAttribute('id');
                });
                if (currentId) {
                    links.forEach(function (link) {
                        var isActive = link.getAttribute('href') === '#' + currentId;
                        link.classList.toggle('active', isActive);
                        link.classList.toggle('fw-semibold', isActive);
                    });
                }
                ticking = false;
            });
        }, { passive: true });
    });
})();
